import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty, isNumber } from '@/utils';
import empty from '../empty.vue';
export default {
  name: 'goods_nav',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    defaultValue: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    parentKey: String
  },
  components: {
    empty: empty
  },
  data: function data() {
    return {
      isEmpty: isEmpty,
      activeTab: ''
    };
  },
  methods: {
    // show_type=4 价格拆分：整数部分保持原字号；小数部分单独缩小展示；小数为 00（或无小数）时不展示
    splitPrice: function splitPrice(price) {
      var str = String(this.$options.filters.moneyFormat(price));
      var dotIndex = str.lastIndexOf('.');
      if (dotIndex === -1) {
        return {
          int: str,
          dec: ''
        };
      }
      var dec = str.slice(dotIndex + 1);
      if (dec === '00' || dec === '') {
        return {
          int: str.slice(0, dotIndex),
          dec: ''
        };
      }
      return {
        int: str.slice(0, dotIndex),
        dec: dec
      };
    },
    // 按列表序号展示固定演示文案：第1个「超值/好物」，第2个「8.5/折」，第3个「立省/6.88」，第4个起默认「超值/好物」
    middleTagLines: function middleTagLines(index) {
      var noDiscount = this.tagConfig.tag_no_discount_text || '超值好物';
      var saveText = this.tagConfig.tag_discount_text || '立省';
      var groups = [[{
        text: noDiscount.slice(0, 2)
      }, {
        text: noDiscount.slice(2)
      }], [{
        text: '8.5',
        cls: 'tag-num'
      }, {
        text: '折'
      }],
      // 立省金额：整数部分保持原字号，小数部分缩小展示，小数为 00 时不展示
      [{
        text: saveText
      }, {
        cls: 'tag-save-num',
        parts: this.splitPrice('20.68')
      }]];
      return groups[index] || groups[0];
    }
  },
  computed: {
    goodsList: function goodsList() {
      var default_value = this.value.default_value || [];
      if (this.parentKey) {
        default_value = this.defaultValue;
      }
      var _this$value$config = this.value.config,
        line_number = _this$value$config.line_number,
        _this$value$config$sh = _this$value$config.show_type,
        show_type = _this$value$config$sh === void 0 ? 1 : _this$value$config$sh,
        is_open_ad = _this$value$config.is_open_ad;
      if (isNumber(line_number)) {
        var num_of_line = {
          1: 2,
          2: 1,
          3: 3,
          4: 1
        }[show_type];
        var endIndex = num_of_line ? num_of_line * line_number : default_value.length;
        if (is_open_ad === '1' && ['1', '3'].includes(show_type + '')) {
          endIndex--;
        }
        return default_value.slice(0, endIndex);
      }
      return default_value;
    },
    tabList: function tabList() {
      var _list$;
      var list = this.value.config.value.filter(function (i) {
        return Boolean(i.flag);
      });
      this.activeTab = (_list$ = list[0]) === null || _list$ === void 0 ? void 0 : _list$.id;
      return list;
    },
    // 价格签相关配置项（show_type=4 时使用）
    tagConfig: function tagConfig() {
      var cfg = this.value && this.value.config || {};
      return {
        tag_discount: cfg.tag_discount !== undefined ? cfg.tag_discount : 9.5,
        tag_discount_text: cfg.tag_discount_text !== undefined ? cfg.tag_discount_text : '立省',
        tag_no_discount_text: cfg.tag_no_discount_text !== undefined ? cfg.tag_no_discount_text : '超值好物',
        tag_btn_text: cfg.tag_btn_text !== undefined ? cfg.tag_btn_text : '抢'
      };
    }
  }
};